import React from 'react';
import { Card, Skeleton } from 'antd';
import TwoColumnsFlexLayout from '../../../shared/components/layout/TwoColumnsFlex.layout';
import { Box } from '../../../shared/components';


export default function LoadingWorkspaceSkeleton(props) {
  const mt = props.mt || props.mt === 0 ? props.mt : 64;
  const hidePageTitle = props.hidePageTitle ? props.hidePageTitle : false;
  return (
    <TwoColumnsFlexLayout
      preset="golden"
      leftContent={(
        <Box p={hidePageTitle ? 0 : 24} mt={mt}>
          {!hidePageTitle && <Skeleton active paragraph={{ rows: 0 }} title={{ width: '60%' }} />}
          <Card bordered={false}>
            <Skeleton active />
          </Card>
        </Box>
      )}
      rightContent={(
        null
      )}
      rightColumnStyle={{ height: '100vh' }}
    />
  );
}
